<script lang="ts">
  import {onDestroy, onMount} from 'svelte';
  import {writable} from 'svelte/store';
  import editorInstance from '../../editor';
  import editorStore from '../../editor.store';
  import {ToolbarButton} from '../components/ToolbarButton';

  const alignment = writable('left');

  $: targetElement = $editorStore.activeComponent as HTMLElement;

  const setAlignment = (target: string) => {
    alignment.set(target);
  };

  const align = (target: string) => {
    if (targetElement) {
      targetElement.style.textAlign = target;
      setAlignment(target);
      editorInstance.history.addHistory('Change Text Alignment');
    }
  };

  const unsubscribe = editorStore.subscribe(store => {
    const storeTargetElement = store.activeComponent as HTMLElement;
    setAlignment(storeTargetElement?.style.textAlign);
  });

  onMount(() => {
    setAlignment(targetElement?.style.textAlign || 'left');
  });

  onDestroy(unsubscribe);

  $: isLeftAligned = $alignment == 'left';
  $: isRightAligned = $alignment == 'right';
  $: isCenterAligned = $alignment == 'center';

  $: modules = [
    {tooltip: 'Left Align', icon: 'fa fa-align-left', isActive: isLeftAligned, onClick: () => align('left')},
    {tooltip: 'Center Align', icon: 'fa fa-align-center', isActive: isCenterAligned, onClick: () => align('center')},
    {tooltip: 'Right Align', icon: 'fa fa-align-right', isActive: isRightAligned, onClick: () => align('right')}
  ];
</script>

<ToolbarButton label="Text Alignment" icon={`fa fa-align-${$alignment || 'left'}`} {modules} />
